import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";

import { getDataGlossarySections } from "./sections.js";

export function DataGlossary() {
  const { t, i18n } = useTranslation();
  const sections = getDataGlossarySections(i18n.language);

  return (
    <Box sx={{ py: 2, px: 3 }}>
      <Typography variant="h5" gutterBottom>
        {t("admin.dataGlossary.title")}
      </Typography>

      {sections.map((section) => (
        <Box key={section.heading} sx={{ mb: 4 }}>
          <Typography variant="h6" gutterBottom>
            {section.heading}
          </Typography>

          <Typography variant="body1" sx={{ mb: 2, whiteSpace: "pre-line" }}>
            {section.intro}
          </Typography>

          <TableContainer component={Paper} variant="outlined">
            <Table
              size="small"
              sx={{
                "& td, & th": {
                  borderRight: "1px solid rgba(224, 224, 224, 1)",
                  verticalAlign: "top",
                  "&:last-child": { borderRight: "none" },
                },
              }}
            >
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: "bold" }}>
                    {t("admin.dataGlossary.term")}
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>
                    {t("admin.dataGlossary.definition")}
                  </TableCell>
                  {section.variant === "durations" ? (
                    <>
                      <TableCell sx={{ fontWeight: "bold" }}>
                        {t("admin.dataGlossary.calculation")}
                      </TableCell>
                      <TableCell sx={{ fontWeight: "bold" }}>
                        {t("admin.dataGlossary.cleaningRules")}
                      </TableCell>
                    </>
                  ) : (
                    <TableCell sx={{ fontWeight: "bold" }}>
                      {t("admin.dataGlossary.dataContext")}
                    </TableCell>
                  )}
                </TableRow>
              </TableHead>
              <TableBody>
                {section.rows.map((row, index) => {
                  const columnCount = section.variant === "durations" ? 4 : 3;
                  return (
                    <TableRow key={index}>
                      <TableCell
                        colSpan={row.isGroupHeader ? columnCount : 1}
                        sx={{
                          ...(row.isGroupHeader && {
                            fontWeight: "bold",
                            backgroundColor: "#f5f5f5",
                          }),
                        }}
                      >
                        {row.term}
                      </TableCell>
                      {!row.isGroupHeader && (
                        <>
                          <TableCell sx={{ whiteSpace: "pre-line" }}>
                            {row.definition}
                          </TableCell>
                          {"calculation" in row ? (
                            <>
                              <TableCell sx={{ whiteSpace: "pre-line" }}>
                                {row.calculation}
                              </TableCell>
                              <TableCell sx={{ whiteSpace: "pre-line" }}>
                                {row.cleaningRules}
                              </TableCell>
                            </>
                          ) : (
                            <TableCell sx={{ whiteSpace: "pre-line" }}>
                              {row.dataContext}
                            </TableCell>
                          )}
                        </>
                      )}
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      ))}
    </Box>
  );
}
